/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_controls_disable_confirm_description = /** @type {(inputs: {}) => string} */ () => {
	return `Esto desactivará permanentemente la tarjeta. Esta acción no se puede deshacer.`
};

const en_cards_controls_disable_confirm_description = /** @type {(inputs: {}) => string} */ () => {
	return `This will permanently disable the card. This action cannot be undone.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_controls_disable_confirm_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_controls_disable_confirm_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_controls_disable_confirm_description", locale)
	if (locale === "es") return es_cards_controls_disable_confirm_description(inputs)
	return en_cards_controls_disable_confirm_description(inputs)
};
export { cards_controls_disable_confirm_description as "cards.controls.disable_confirm_description" }